<template>
    <table class="table w-full table-auto border-collapse">
        <thead class="">
        <tr>
            <th class="text-left">Category</th>
            <th class="!text-center">Last 100 Attempts</th>
            <th class="!text-center">All-Time Attempts</th>
            <th class="!text-right">Average Score (Last 100 Attempts)</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <template
            v-for="(
                    focusArea, index
                ) in studentPerformance.focus_area_scores"
        >
            <tr
                :class="
                        'hover:cursor-pointer hover:bg-gray-50' +
                        ' ' +
                        (focusArea.showCategories === true
                            ? '!border-b-0 border-t'
                            : '')
                    "
                @click="toggleCategory(index)"
            >
                <td class="text-left">
                    {{ getFocusArea(focusArea.fa_id).title }}
                </td>
                <td class="text-center">
                    {{ focusArea.q_correct }}/{{ focusArea.q_total }}
                    correct
                </td>
                <td class="text-center">
                    {{
                        studentPerformance
                            .lifetime_focus_area_question_counts[
                        "fa_id_" + focusArea.fa_id
                            ]
                    }}
                </td>
                <td class="text-right">
                    <score-label :score="focusArea.avg"/>
                </td>
                <td class="text-right">
                    <div class="flex items-center justify-end">
                        <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 1.5L6 6.5L11 1.5"
                                stroke="#777777"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                </td>
            </tr>
            <template
                v-for="category in focusAreas[focusArea.fa_id - 1]
                        .categories"
                v-if="
                        focusAreas[focusArea.fa_id - 1].showCategories === true
                    "
            >
                <tr class="!border-b-0">
                    <td class="!py-0 text-left">
                        <div class="border-l-3 py-4 pl-4 text-gray-750">
                            {{ category.title }}
                        </div>
                    </td>
                    <td class="!text-center">
                        {{
                            getCategoryScore(category.id).q_total -
                            getCategoryScore(category.id).q_missed
                        }}/{{ getCategoryScore(category.id).q_total }}
                    </td>
                    <td class="!text-center">
                        <!--                                                        {{ getCategoryScore(category.id).recent_questions_correct }}/{{-->
                        <!--                                                            getCategoryScore(category.id).recent_questions_answered-->
                        <!--                                                        }}-->
                    </td>
                    <td class="!text-right">
                        <score-label
                            :score="getCategoryScore(category.id).avg"
                        />
                    </td>
                </tr>
            </template>
        </template>
        </tbody>
    </table>
</template>
<script>
import ScoreLabel from "@/Components/ScoreLabel";

export default {
    name: "GroupStudentPerformanceOverviewTable",
    components: {ScoreLabel},
    props: {
        studentPerformance: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            focusAreas: this.$page.props.focusAreas,
        };
    },
    methods: {
        toggleCategory(faId) {
            let index = parseInt(faId.substring(6, 7) - 1);

            this.focusAreas.forEach(function (focusArea, faIndex) {
                if (faIndex !== index) {
                    focusArea.showCategories = false;
                }
            });

            this.focusAreas[index].showCategories =
                !this.focusAreas[index].showCategories;
        },
        getFocusArea(focusAreaId) {
            let focusArea = _.find(
                this.$page.props.focusAreas,
                function (focusArea) {
                    return focusArea.id === focusAreaId;
                }
            );

            return focusArea;
        },
        getCategoryScore(categoryId) {
            return this.studentPerformance.category_scores[
            "cat_id_" + categoryId
                ];
        },
    },
};
</script>
